import { useMemo } from 'react';

import { Trans } from '@lingui/react/macro';
import { useAtomValue } from 'jotai';

import { selectedPlanAtom } from '../../../atoms';

import { WaitingPeriodsTable } from './WaitingPeriodsTable';

export const WaitingPeriodsSection = () => {
  // atoms
  const currentPlan = useAtomValue(selectedPlanAtom);

  // Transform Zuub waiting periods data
  const waitingPeriodsData = useMemo(() => {
    if (!currentPlan?.waitingPeriods || currentPlan.waitingPeriods.length === 0) {
      return { waitingPeriods: [], isValid: false };
    }

    return {
      waitingPeriods: currentPlan.waitingPeriods,
      isValid: true,
    };
  }, [currentPlan]);

  // Only show data if we have valid waiting periods data
  if (!waitingPeriodsData.isValid) {
    return (
      <div className="vai-text-center vai-text-gray-500 vai-py-8 vai-bg-gray-50 vai-rounded-lg">
        <Trans>No waiting periods data available for the selected plan.</Trans>
      </div>
    );
  }

  return <WaitingPeriodsTable data={waitingPeriodsData.waitingPeriods} />;
};
